import { z } from 'zod';
import { IsoTimestampSchema, UuidSchema } from './primitives.js';
import { CardStatusSchema, CardTypeSchema } from './enums.js';
/**
 * Card issued via Swan. Mirrors the `swan_cards` table.
 *
 * ⚠️ COMPLIANCE: we never store the full PAN, the CVV, or the PIN.
 * Only `masked_pan` (e.g. "•••• •••• •••• 4242") is allowed. See
 * COMPLIANCE-PLAYBOOK §10 Critical errors #1.
 */
export const CardSchema = z.object({
    id: UuidSchema,
    account_id: UuidSchema,
    swan_card_id: z.string().min(1),
    type: CardTypeSchema,
    status: CardStatusSchema,
    /** "•••• •••• •••• 4242". Never the full PAN. */
    masked_pan: z.string().regex(/^[•\s]+\d{4}$/, 'Must be a masked PAN with only last 4 digits'),
    expiry_month: z.number().int().min(1).max(12),
    expiry_year: z.number().int().min(2024).max(2099),
    spending_limits: z
        .object({
        daily_cents: z.number().int().nonnegative().nullable(),
        monthly_cents: z.number().int().nonnegative().nullable(),
        per_transaction_cents: z.number().int().nonnegative().nullable(),
    })
        .nullable(),
    created_at: IsoTimestampSchema,
});
//# sourceMappingURL=card.js.map